.yes-no-multiselect__container {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.yes-no-multiselect__container .yes-no-multiselect__title {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
}

.yes-no-multiselect__container .yes-no-multiselect__description {
  color: #555768;

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;

  white-space: pre-wrap;
}

.yes-no-multiselect__choices-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 24px;
}

.yes-no-multiselect__container .yes-no-multiselect__label {
  cursor: pointer;

  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  gap: 8px;

  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  padding: 4px 8px;
  border: 1px solid transparent;
}

.yes-no-multiselect__danger .yes-no-multiselect__label {
  color: var(--color-danger-medium);
}

.yes-no-multiselect__container .yes-no-multiselect__label:hover {
  border-color: gray;
  border-radius: 8px;
}

.yes-no-multiselect__container .yes-no-multiselect__label-disabled {
  cursor: not-allowed;
}

.yes-no-multiselect__container .yes-no-multiselect__selected {
  fill: #22BDFF;
}